import { Card, CardContent, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ReactComponent as DroneWithGroundIcon } from 'assets/icons/droneWithGround.svg';
import { ReactComponent as DroneIcon } from 'assets/icons/drone.svg';
import { ReactComponent as CautionIcon } from 'assets/icons/caution.svg';
import { ReactComponent as RestrictedIcon } from 'assets/icons/restricted.svg';
import { $white } from 'styles/colors';

const styles = {
	main: {
		padding: 20,
		paddingTop: 0,
		paddingBottom: 0
	},
	card: {
		color: $white,
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center'
	},
	title: {
		fontWeight: 'bold'
	},
	icon: {
		height: '100px',
		minWidth: '150px'
	},
	fadedIcon: {
		strokeOpacity: '50%'
	},
	iconsContainer: {
		height: 100,
		width: 150
	},
	cautionOverlay: {
		position: 'relative',
		left: '49px',
		top: '-80px',
		zIndex: 100
	},
	restrictedOverlay: {
		position: 'relative',
		left: '39px',
		top: '-94px',
		zIndex: 100
	}
};
const AirspaceStatus = ({ advisoriesObject }) => {
	const { overview, color } = advisoriesObject;
	const { full, icon, short } = overview;
	const { hex } = color;
	const useStyles = makeStyles(styles);
	const classes = useStyles();

	const DroneWithCaution = (
		<div className={classes.iconsContainer}>
			<DroneIcon className={classes.icon} />
			<CautionIcon className={classes.cautionOverlay} />
		</div>
	);

	const DroneWithRestricted = (
		<div className={classes.iconsContainer}>
			<DroneIcon className={[classes.icon, classes.fadedIcon].join(' ')} />
			<RestrictedIcon className={classes.restrictedOverlay} />
		</div>
	);

	const iconMap = {
		clear: <DroneWithGroundIcon className={classes.icon} />,
		warning: DroneWithCaution,
		critical: DroneWithRestricted
	};

	return (
		<div className={classes.main}>
			<Card className={classes.card} style={{ backgroundColor: hex }}>
				<CardContent>
					<Typography component='h5' variant='h5' className={classes.title}>
						{short}
					</Typography>
					<Typography variant='subtitle1'>{full}</Typography>
				</CardContent>
				{iconMap[icon]}
			</Card>
		</div>
	);
};

export default AirspaceStatus;
